import { doconTheme as doconThemeV2 } from '../V2/theme/default';
var doconTheme = {
    v2: doconThemeV2
};
export { doconTheme };
